import { fetchAuthSession } from 'aws-amplify/auth';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3001';

async function authHeaders({ forceRefresh = false } = {}) {
  try {
    const session = await fetchAuthSession({ forceRefresh });
    const token = session.tokens?.idToken?.toString();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

// Wrapper that retries once on 401 with a force-refreshed token. Cognito ID
// tokens expire after 1h; long polls (e.g. dashboard / research runs) cross
// that boundary regularly and need a fresh token without a sign-in round-trip.
async function fetchWithAuthRetry(input, init = {}) {
  const headers = { ...(init.headers || {}), ...(await authHeaders()) };
  let res = await fetch(input, { ...init, headers });
  if (res.status !== 401) return res;
  // One retry with a forced token refresh.
  const refreshed = await authHeaders({ forceRefresh: true });
  if (!refreshed.Authorization) return res; // refresh failed; surface the 401
  const retriedHeaders = { ...(init.headers || {}), ...refreshed };
  res = await fetch(input, { ...init, headers: retriedHeaders });
  return res;
}

export async function apiGet(path) {
  const res = await fetchWithAuthRetry(`${API_BASE}${path}`);
  if (!res.ok) throw new Error(`${res.status} ${await res.text()}`);
  return res.json();
}

export async function apiPost(path, body) {
  const res = await fetchWithAuthRetry(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: body == null ? undefined : JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`${res.status} ${await res.text()}`);
  return res.json();
}

export async function apiDelete(path) {
  const res = await fetchWithAuthRetry(`${API_BASE}${path}`, { method: 'DELETE' });
  if (!res.ok) throw new Error(`${res.status} ${await res.text()}`);
  return res.json();
}

export async function apiPut(path, body) {
  const res = await fetchWithAuthRetry(`${API_BASE}${path}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: body == null ? undefined : JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`${res.status} ${await res.text()}`);
  return res.json();
}
